import { WorkspaceSkeleton } from "./workspace-skeleton";

export function FullPageLoader() {
  return <WorkspaceSkeleton />;
}
